/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseAuthorFragment, AuthorFragment, FullAuthorFragment} from '@amblique/contentful/app/contentful/fragments/author';

/**
 * Get a single Author by ID (base - scalars only)
 */
export const getBaseAuthorById = gql`
  ${BaseAuthorFragment}

  query GetBaseAuthorById($id: String!, $locale: String!, $preview: Boolean) {
    author(id: $id, locale: $locale, preview: $preview) {
      ...BaseAuthorFragment
    }
  }
`;

/**
 * Get a single Author by ID (standard - 1 level deep)
 */
export const getAuthorById = gql`
  ${AuthorFragment}

  query GetAuthorById($id: String!, $locale: String!, $preview: Boolean) {
    author(id: $id, locale: $locale, preview: $preview) {
      ...AuthorFragment
    }
  }
`;

/**
 * Get a single Author by ID (full - 2 levels deep)
 */
export const getFullAuthorById = gql`
  ${FullAuthorFragment}

  query GetFullAuthorById($id: String!, $locale: String!, $preview: Boolean) {
    author(id: $id, locale: $locale, preview: $preview) {
      ...FullAuthorFragment
    }
  }
`;

/**
 * Get all Author entries with pagination (base - scalars only)
 */
export const getBaseAuthors = gql`
  ${BaseAuthorFragment}

  query GetBaseAuthors(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AuthorOrder]
    $where: AuthorFilter
    $preview: Boolean
  ) {
    authorCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseAuthorFragment
      }
    }
  }
`;

/**
 * Get all Author entries with pagination (standard - 1 level deep)
 */
export const getAuthors = gql`
  ${AuthorFragment}

  query GetAuthors(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AuthorOrder]
    $where: AuthorFilter
    $preview: Boolean
  ) {
    authorCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...AuthorFragment
      }
    }
  }
`;

/**
 * Get all Author entries with pagination (full - 2 levels deep)
 */
export const getFullAuthors = gql`
  ${FullAuthorFragment}

  query GetFullAuthors(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AuthorOrder]
    $where: AuthorFilter
    $preview: Boolean
  ) {
    authorCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullAuthorFragment
      }
    }
  }
`;
